import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "caret"]

  connect() {
    this.panel = document.querySelector('[data-player-search-form--toggle-target="panel"]')
  }

  toggle(event) {
    event.preventDefault()
    if (!this.panel) return

    const isHidden = this.panel.classList.toggle("hidden")
    this.element.setAttribute("aria-expanded", String(!isHidden))
    this.element.classList.toggle("is-active", !isHidden)
  }
}
